// formSettingsUtils.js

import { sortLayoutsByConfiguredOrder } from 'utilities/LayoutOrder';
import {
  DEFAULT_FORM_DESCRIPTION,
  DEFAULT_FORM_KEY,
  DEFAULT_FORM_TITLE,
} from 'services/forms/FormModel';

function normalizeString(value) {
  return String(value || '').trim();
}

export function buildFormSettingsDraft(form) {
  return {
    description: normalizeString(form?.description),
    isDefault: Boolean(form?.isDefault),
    key: normalizeString(form?.key),
    title: normalizeString(form?.title) || DEFAULT_FORM_TITLE,
  };
}

export function canSaveFormSettingsDraft(draft, savedDraft) {
  if (!normalizeString(draft?.title)) {
    return false;
  }

  return JSON.stringify(draft) !== JSON.stringify(savedDraft);
}

export function buildVisibleFormsForSettings(forms = []) {
  const persisted = Array.isArray(forms) ? forms : [];
  const defaultForm = persisted.find((form) => form?.isDefault || form?.key === DEFAULT_FORM_KEY) || null;
  const others = sortLayoutsByConfiguredOrder(
    persisted.filter((form) => form?.key !== defaultForm?.key),
  );

  if (defaultForm) {
    return [defaultForm, ...others];
  }

  return [{
    description: DEFAULT_FORM_DESCRIPTION,
    isDefault: true,
    isVirtual: true,
    key: DEFAULT_FORM_KEY,
    title: DEFAULT_FORM_TITLE,
  }, ...others];
}

export function isVirtualFormDoc(form) {
  return Boolean(form?.isVirtual);
}
